'use client';
import { useRef } from 'react';
import { type DeviceType, getDeviceType } from '.';

export const useDeviceType = (): DeviceType => {
  const isClient = typeof window !== 'undefined';
  const deviceType = useRef(isClient ? getDeviceType(window.navigator.userAgent) : 'mobile');
  return deviceType.current;
};
